import { tokens } from "@/lib/constants/tokens";

/** Matches `Header` (`h-16`) for viewport theater sizing on game pages. */
export const SITE_HEADER_HEIGHT = "4rem";

export const GAME_THEATER_STAGE_HEIGHT = `calc(100dvh - ${SITE_HEADER_HEIGHT})`;

/** Full viewport theater height (no site header) for game overlay and direct game pages. */
export const GAME_THEATER_STAGE_HEIGHT_FULL = "100dvh";

/** Opaque fill for the theater player slot (matches `Footer` `bg-ink`, --ink token). */
export const GAME_THEATER_PLAYER_BACKGROUND = tokens.ink;
export const GAME_THEATER_PLAYER_BG_CLASS = "bg-ink";

/** Clearance above expanded metadata when scrolled into view (sticky header + gap). */
export const METADATA_EXPAND_SCROLL_MARGIN_TOP = `calc(${SITE_HEADER_HEIGHT} + 1rem)`;

/** Opacity transition when game content replaces the loading overlay. */
export const GAME_PLAYER_READY_FADE_MS = 300;
